import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import messages from '../../messages';

import { DropdownTogglerWrapper, StyledAddIcon, StyledRemoveIcon } from './styles';

type DropdownTogglerProps = {
    dropdownId: 'playoffFormat' | 'tieBreaking';
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

const DropdownToggler: FC<DropdownTogglerProps> = ({ dropdownId, isOpen, setIsOpen }) => {
    const intl = useIntl();
    const onClick = (): void => {
        setIsOpen(!isOpen);
        // TODO - scroll to bottom upon click
    };
    return (
        <DropdownTogglerWrapper
            aria-controls="content-body-wrapper"
            aria-expanded={isOpen ? 'true' : 'false'}
            aria-label={
                isOpen
                    ? intl.formatMessage(messages.ariaLabels[dropdownId].toggler.collapse)
                    : intl.formatMessage(messages.ariaLabels[dropdownId].toggler.expand)
            }
            $isOpen={isOpen}
            onClick={onClick}
        >
            {isOpen ? <StyledRemoveIcon /> : <StyledAddIcon />}
        </DropdownTogglerWrapper>
    );
};

export default DropdownToggler;
